"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TokenValidator = _interopRequireDefault(require("../../../core/TokenValidator"));

var _FetchHelper = _interopRequireDefault(require("../../../core/FetchHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RequestWorkflowService =
/*#__PURE__*/
function () {
  function RequestWorkflowService(url, kundennummer, obtainTokenMethod, removeTokenMethod) {
    _classCallCheck(this, RequestWorkflowService);

    this.url = url;
    this.kundennummer = kundennummer;
    this.obtainTokenMethod = obtainTokenMethod;
    this.removeTokenMethod = removeTokenMethod;
  }

  _createClass(RequestWorkflowService, [{
    key: "getRequest",
    value: function getRequest() {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].get(this.url + "/requestWorkflow/", options);
    }
  }, {
    key: "getRequestById",
    value: function getRequestById(requestId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].get(this.url + "/requestWorkflow/getRequest/" + requestId, options);
    }
  }, {
    key: "approveRequest",
    value: function approveRequest(selectedItem) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].put(this.url + "/requestWorkflow/approve/" + selectedItem, options);
    }
  }, {
    key: "declineRequest",
    value: function declineRequest(selectedItem, message) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].put(this.url + "/requestWorkflow/decline/" + selectedItem + "/" + message, options);
    }
  }, {
    key: "bookRequest",
    value: function bookRequest(request) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: request
      };
      return _FetchHelper["default"].put(this.url + "/requestWorkflow/bookRequest/", options);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file, meetingId, userId, fileName) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var formData = new FormData();
      formData.append("uploadedFile", file);
      var options = {
        headers: {
          "enctype": "multipart/form-data",
          "authorization": token
        },
        body: formData
      };
      return _FetchHelper["default"].post(this.url + "/requestWorkflow/uploadFile/" + meetingId + "/" + userId + "/" + fileName, options);
    }
  }]);

  return RequestWorkflowService;
}();

exports["default"] = RequestWorkflowService;
;